// extracted by mini-css-extract-plugin
module.exports = {"mention":"mention-pill_mention_gEB"};